<style lang="scss" scoped>
.employee-dashboard {
	&__list {
		margin-bottom: -40px;
	}
	&__section {
		padding-bottom: 30px;
		&:last-child {
			padding-bottom: 0;
		}
	}
}
</style>

<template lang="pug">
.employee-dashboard
    empty(message="Your school has no apps, please contact your school admin.", :central="true" :visible="!$apollo.loading && filteredCompanies.length === 0")
    loader(v-if='$apollo.loading', :message="trans('page_dashboard.m_loading')", :visible='$apollo.loading')
    template(v-else)
        .employee-dashboard__section
            h2.employee-dashboard__title Your classrooms
            el-row(:gutter='50')
                el-col(:span="8", v-for="classroom in sortedClassrooms", :key="classroom.id")
                    classroom-tile(:classroom='classroom')
                el-col(:span="8")
                    create-classroom-tile(:showIntroduction="sortedClassrooms.length === 0")
        .employee-dashboard__section
            h2.employee-dashboard__title Your applications
            el-row(:gutter="50")
                el-col(v-for='app in filteredCompanies', :span="4", :key="app.id")
                    employee-tile(:app="app")
</template>

<script>
import gql from "graphql-tag";
import { sortBy } from "lodash";
import EmployeeTile from "@/components/apps/appsList/cards/employee/Tile";
import ClassroomTile from "@/components/apps/appsList/cards/ClassroomTile";
import CreateClassroomTile from "@/components/apps/appsList/cards/employee/CreateClassroomTile";

export default {
	components: {
		EmployeeTile,
		CreateClassroomTile,
		ClassroomTile
	},

	computed: {
		sortedClassrooms() {
			return sortBy(this.User.Classrooms, "name");
		},
		filteredCompanies() {
			if (this.User && this.User.Companies) {
				return this.User.Companies.filter(company => {
					if (["wonde"].includes(company.slug)) return false;
					if (company.approved === false) return false;
					if (company.classroom_uuid) return false;

					return true;
				});
			} else {
				return [];
			}
		}
	},

	apollo: {
		User: {
			query: gql`
				{
					User {
						id
						first_name
						last_name
						is_admin
						display_name
						is_contact
						School {
							id
						}
						Classrooms {
							id
							name
							description
							Icon {
								type
								value
							}
						}
						Companies {
							id
							application_name
							slug
							name
							website
							description
							approved
							requires_renewal
							redirect
							classroom_uuid
							client_id
							Icon {
								type
								value
							}
							launch_url
							sp_active
							sso_active
						}
					}
				}
			`
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/apps/appsList/cards/employee/Homepage.vue